import findWithRegex from 'find-with-regex'
import emojiRegexRGI from 'emoji-regex/RGI_Emoji.js'

const emojiRegex = emojiRegexRGI()

export default function (contentBlock, callback) {
  findWithRegex(emojiRegex, contentBlock, callback)
}
